module.exports = __webpack_public_path__ + "img/reference57.a1193301.jpg";